<template>
	<InputRow
		class="value-row-input value-row-dropdown"
		:class="{ hidden: hidden }"
		:for-id="uuid.toString()"
		:label="label"
	>
		<select
			:id="uuid.toString()"
			class="input-wrapper dropdown-wrapper"
			:value="modelValue"
			:required="required"
			:disabled="isDisabled"
			@input="update(($event.target as HTMLSelectElement).value)"
		>
			<option v-if="!disableNoSelection">-</option>
			<option
				v-for="option in optionsArray"
				:key="
					typeof option.value === 'boolean'
						? String(option.value)
						: option.value
				"
				class="dropdown-value"
				:value="option.value"
				:selected="option.value === modelValue"
			>
				{{ option.label }}
			</option>
		</select>
	</InputRow>
</template>

<script setup lang="ts">
import { useOptionsFlatMap } from "@/composables/useOptionsToArray";
import { useUserStore } from "@/store/useUserStore";
import { computed } from "vue";

const props = withDefaults(
	defineProps<{
		modelValue: any;
		required?: boolean;
		label: string;
		options: any;
		config?: any;
		disableNoSelection?: boolean;
		readOnly?: boolean;
		hidden?: boolean;
		uuid?: number;
		validations?: any;
	}>(),
	{
		required: false,
		readOnly: false,
		hidden: false,
		disableNoSelection: true,
		uuid: 0,
		validations: {},
	},
);

const emit = defineEmits<{
	"update:modelValue": [value: unknown];
}>();

/**
 * Emits the value passed to the function.
 *
 * @param value - The new value to emit
 */
function update(value: any) {
	emit("update:modelValue", value);
}

const userStore = useUserStore();
const isDisabled = computed(() => {
	return props.readOnly || userStore.user?.role !== "intermediary";
});

const optionsArray = computed(() => useOptionsFlatMap(props.options));
</script>

<style lang="scss">
.value-row.hidden {
	display: none;
}

.value-row-dropdown select:disabled {
	appearance: none;
}
</style>
